import { Box, Typography } from "@mui/material";
import {
  CHART_CONTAINER_HEIGHT,
  SMALL_CHART_HEIGHT,
} from "../../system-health/common/values";

import AllLocationsEventsFilterDropdownContainer from "../../../../../common/components/locations/recent-events/AllLocationsEventsFilterDropdownContainer";
import { AutocompleteOptionType } from "../../../../../common/models/autocomplete";
import Chart from "react-apexcharts";
import CircularLoading from "../../../../../common/components/progress/CircularLoading";
import SimplePaperWrapper from "../../../../../common/components/item/SimplePaperWrapper";
import StatisticsNoDataView from "./StatisticsNoDataView";
import { TimePeriod } from "../../../../../API";
import TimePeriodFilter from "./TimePeriodFilter";
import { apexChartsTooltipStyles } from "../../../../../common/components/apexchart/StyledChart";
import isEqual from "lodash/isEqual";
import { useLocationsFilterDropdown } from "../hooks/useLocationsFilterDropdown";
import { useState } from "react";
import { useVisitorsChart } from "../hooks/useVisitorsChart";

const VisitorsContainer = (): JSX.Element => {
  const [activeTimePeriod, setActiveTimePeriod] = useState<TimePeriod>(
    TimePeriod.ONE_WEEK
  );

  const {
    location,
    handleLocationChange,
    tagLocations,
    handleTagLocationsChange,
  } = useLocationsFilterDropdown();

  const { series, options, loading, refetching, showNoData, refetchChartData } =
    useVisitorsChart(
      activeTimePeriod,
      location?.value
        ? [location.value]
        : tagLocations?.map(l => l?.value ?? "") ?? null
    );

  const handleTimePeriodChange = (timePeriod: TimePeriod): void => {
    if (timePeriod !== activeTimePeriod) {
      setActiveTimePeriod(timePeriod);
    }
  };

  const setLocationFilter = (locationValue: AutocompleteOptionType): void => {
    if (locationValue?.value !== location?.value) {
      handleLocationChange(locationValue, activeTimePeriod, refetchChartData);
    }
  };

  const setTagFilter = (locations: AutocompleteOptionType[] | null): void => {
    if (!isEqual(locations, tagLocations)) {
      handleTagLocationsChange(locations, activeTimePeriod, refetchChartData);
    }
  };

  return (
    <SimplePaperWrapper
      sx={{
        padding: "1.5em",
        width: "100%",
        height: CHART_CONTAINER_HEIGHT,
        borderRadius: "8px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          marginBottom: "1em",
        }}
      >
        <Typography variant="h5">Gate guard</Typography>
        <Box
          sx={{
            display: "flex",
            marginLeft: "auto",
          }}
        >
          <TimePeriodFilter
            activePeriod={activeTimePeriod}
            setActivePeriod={handleTimePeriodChange}
          />
        </Box>
      </Box>
      <Box
        sx={{
          width: "180px",
        }}
      >
        <AllLocationsEventsFilterDropdownContainer
          setLocation={setLocationFilter}
          setTagLocations={setTagFilter}
        />
      </Box>
      {(loading || refetching) && <CircularLoading />}
      {!loading && !showNoData && (
        <Box sx={apexChartsTooltipStyles}>
          <Chart
            options={options}
            series={series}
            height={SMALL_CHART_HEIGHT}
            type="line"
          />
        </Box>
      )}
      {showNoData && <StatisticsNoDataView />}
    </SimplePaperWrapper>
  );
};

export default VisitorsContainer;
